// extracted by css-extract-rspack-plugin
export default {"item":"_ed3e66f6","link":"_2f5b883","image":"_5a1f3d44","info":"_dab25b2d","name":"_5ca3ccc4","vertical":"_c0ad6d1","title":"_21c7df23"};